import type { PropsWithChildren } from 'react'

const ScrollSpacer = (props: PropsWithChildren) => (
  <div
    className='h-[--scroll-spacer-height] w-full playsee-mb:hidden'
    {...props}
  />
)

export default ScrollSpacer
